import { sv } from "@dhx/ts-common/dom";
import { dropShadow, shadow } from "./Filters";
import { IComposeLayer, ILikeSeria} from "./types";
import { IFitPosition } from "@dhx/ts-common/html";


export class ComposeLayer implements IComposeLayer {
	private _data:ILikeSeria[] = [];
	private _sizes: IFitPosition = { left:20, right:20, top:10, bottom:10 };

	add(obj: any): void {
		this._data.push(obj);
	}
	clear() {
		this._data.forEach(item => item.destructor && item.destructor());
		this._data = [];
	}
	getSizes() {
		return this._sizes;
	}
	toVDOM(width:number, height:number){
		const sizes = { left:20, right:20, top:10, bottom:10 };

		const toPaint = this._data.filter(l => !l.dataReady || l.dataReady().length);
		this._data.forEach(l => !l.scaleReady || l.scaleReady(sizes));

		let shift = 0;
		let shiftCount = 0;
		toPaint.forEach(item => {
			if (item.seriesShift){
				shift += item.seriesShift();
				shiftCount++;
			}
		});
		const step = shift/shiftCount;
		shift = shiftCount ? (step-shift)/2 : 0;
		toPaint.forEach(item => {
			if (item.seriesShift){
				item.seriesShift(shift);
				shift += step;
			}
		});

		this._sizes = sizes;
		const chartsContent = sv("g",
			{
				transform: `translate(${sizes.left}, ${sizes.top})`
			},
			[
				sv("rect.dhx_chart-graph_area", { width: width - sizes.left - sizes.right, height: height - sizes.top - sizes.bottom, fill:"transparent" }), 
				toPaint.map(item => {
					return item.paint(width - (sizes.left+sizes.right), height - (sizes.top+sizes.bottom));
				})
			]
		);

		const defs = sv("defs", [dropShadow(), shadow()]);

		return sv("svg", {
			width,
			height
		}, [defs, chartsContent ]);
	}
}

